import axios, { AxiosInstance } from 'axios';
import { getAxiosInstanceImpl } from '~/utils/networkUtilImpl';

/**
 * base axios instance for connect to backend api
 *
 * @param noAuth : no need bearer authorization -> for some apis: login, register, and other public apis
 * @returns: AxiosInstance
 *
 * @usage getAxiosInstance().post(url, {...data}).then( (data) => {console.log(data)} )
 * @usage const data = await getAxiosInstance().get()
 */

export interface GetAxiosInstanceProps {
  noAuth?: boolean;
  hideSystemError?: boolean;
}
export const getAxiosInstance = (props?: GetAxiosInstanceProps): AxiosInstance => {
  return getAxiosInstanceImpl(props);
};
